import { queryOptions } from '@tanstack/react-query';

import { getNudgesForProduct } from './api';

import { RQ_NUDGES_KEY } from '@/modules/ReactQuery/cacheKeys';

export function nudgesQueryOptions(productIds: number[]) {
  const ids = productIds.join(',');

  return queryOptions({
    queryKey: [RQ_NUDGES_KEY, ids],
    queryFn: async () => {
      const res = await getNudgesForProduct(ids);
      return res?.data;
    },
  });
}
